shadow$provide[399] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vMask;

float ease(float t) {
  t = clamp(t, 0.0, 1.0);
  return t * t * (3.0 - 2.0 * t);
}

vec4 maskColor() {
  if (vMask <= 0.0) discard;
  return vec4(vec3(1.0), ease(vMask));
}
`;

};